import React from 'react'

const InputField = ({ containerClassName, labelFor, labelClassName = '', children, type = '', id = '', name = '', className = '', placeholder = '', required = '', onChange = a => a, onBlur = b => b, value = '', min = '', max = '' }) => {
  return (
    <div className={`${containerClassName || 'my-2'}`}>
      {children && <label htmlFor={labelFor} className={`${labelClassName} block mb-2 text-sm font-bold text-black dark:text-black`}>{children}</label>}
      <input
        type={type}
        id={id}
        name={name}
        min={min}
        className={`${className} max-w-lg border border-gray-100 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
        placeholder={placeholder}
        required={required}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        max={max}
      />
    </div>
  )
}

export default InputField
